import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { IAuthenticationService } from "services/AuthenticationService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import * as auth from "../redux/AuthRedux";
import { toast } from "react-toastify";

const ExternalAccessLinkHandler: React.FC = () => {
  const authService = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const verifyExternalAccessUserFromToken = useCallback(async () => {
    try {
      const tokens = await authService.verifyExternalAccessUserFromToken(token!);
      dispatch(
        auth.actions.setExternalAccessTokens({
          singleUseToken: token!,
          externalAccessToken: tokens.token!,
          accessPath: tokens.accessPath!,
        })
      );
      navigate(`/${tokens.accessPath}`);
    } catch (error) {
      console.error(error);
      toast.error("Invalid link. This may mean the link has expired or has already been used.");
      dispatch(auth.actions.logout());
      navigate("/auth");
    }
  }, [authService, dispatch, navigate, token]);

  useEffect(() => {
    const handleExternalAccessLink = async () => {
      if (token === undefined) {
        navigate("/auth");
        return;
      }
      await verifyExternalAccessUserFromToken();
    };

    handleExternalAccessLink();
  }, [dispatch, navigate, token, verifyExternalAccessUserFromToken]);

  return <></>;
};

export default ExternalAccessLinkHandler;
